import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface FormSubmitSectionProps {
  isSubmitted: boolean;
  isSubmitting: boolean;
  submitError: string | null;
  printView: boolean;
  hasValidationErrors?: boolean;
}

/**
 * Submit section component for the dynamic form
 * Displays submit button, submitted message, or error state
 */
export const FormSubmitSection = ({
  isSubmitted,
  isSubmitting,
  submitError,
  printView,
  hasValidationErrors,
}: FormSubmitSectionProps) => {
  return (
    <>
      {/* Error banner — shows validation errors (client-side) or server errors */}
      {(hasValidationErrors || submitError) && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              {submitError ??
                'Please complete all required fields before submitting.'}
            </AlertDescription>
          </Alert>
        </div>
      )}

      {/* Submit Button */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 print:hidden">
        {isSubmitted && (
          <p className="text-center">This submission has been submitted.</p>
        )}
        {!isSubmitted && !printView && (
          <div className="flex justify-end">
            <Button
              type="submit"
              disabled={isSubmitting}
              size="lg"
              className="mx-8 px-8 w-full sm:w-auto"
            >
              {isSubmitting ? 'Submitting...' : 'Submit Application'}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
